/** Strict editing syntax: one decimal comma OR point, no grouping or partial parses. */
export function parseFormNumber(raw, { required = false, min, max, precision, step } = {}) {
  const text = String(raw ?? '').trim().replace(',', '.');
  if (!text) return { text: '', value: null, error: required ? 'required' : '' };
  if (!/^[+-]?(?:\d+(?:\.\d+)?|\.\d+)$/.test(text)) {
    return { text, value: null, error: 'number' };
  }
  const value = Number(text);
  if (!Number.isFinite(value)) return { text, value: null, error: 'number' };
  if (min !== undefined && min !== '' && value < Number(min)) return { text, value, error: 'min' };
  if (max !== undefined && max !== '' && value > Number(max)) return { text, value, error: 'max' };
  if (precision !== undefined && (text.split('.')[1]?.length ?? 0) > Number(precision)) {
    return { text, value, error: 'precision' };
  }
  if (step !== undefined && step !== 'any' && Number(step) > 0) {
    const increment = (value - Number(min || 0)) / Number(step);
    if (Math.abs(increment - Math.round(increment)) > 1e-8) return { text, value, error: 'step' };
  }
  return { text, value, error: '' };
}

/** Unit conversion at form boundaries, retaining empty and incomplete drafts. */
export function scaleFormNumber(raw, factor) {
  const parsed = parseFormNumber(raw);
  if (parsed.value === null) return raw ?? '';
  // Remove multiplication's binary noise (0.07 * 100) at JS numeric precision.
  return Number((parsed.value * factor).toPrecision(15));
}
